import ApprovalsBanner from "../../components/leads/quotes/live/approvals/ApprovalsBanner";
import LoadingWheel from "../../components/shared/LoadingWheel";
import useCustomerDetails from "../../data/useCustomerDetails";
import { CheckFeatureFlag } from "../../hooks/useFeatureFlag";
import Dashboard from "./Dashboard";
import TmeDashboard from "./TmeDashboard";

/**
 * Picks which dashboard "/" shows.
 *
 * A switch rather than a flag inside Dashboard.tsx, because the two pages differ in more than
 * layout: Dashboard.tsx redirects every non-admin away from "/" entirely (to /leads, /vehicles or
 * /accounts), which would mean no TME user but an admin ever saw the management dashboard. Keeping
 * them as separate components keeps that redirect where it belongs and guarantees non-TME
 * customers see no change at all.
 *
 * Waits for the feature list before deciding. Without that, a TME user would land on the stock
 * dashboard for a moment and its redirect effect would fire before the flag arrived.
 */
export default function DashboardHome() {
  const { features } = useCustomerDetails();
  const isTme = CheckFeatureFlag("TME");

  if (features.isLoading && !features.data) {
    return (
      <div className="flex h-full items-center justify-center">
        <LoadingWheel />
      </div>
    );
  }

  // Approvers (call centre) see offers waiting on them before anything else.
  return (
    <>
      <div className="mb-4 empty:hidden">
        <ApprovalsBanner />
      </div>
      {isTme ? <TmeDashboard /> : <Dashboard />}
    </>
  );
}
